<dgx-input-session-form-partial
  [session]="session"
  [inputType]="params.inputType"
  [isFromIntegrations]="params.isFromIntegrations"
  (sessionChange)="handleSessionChange($event)"
  (validateChange)="handleValidateChange($event)"
  (focusout)="handleFocusout()"
>
</dgx-input-session-form-partial>
